import { twMerge } from 'tailwind-merge';
import type { HtmlElementProps } from '@/types';
import { classes } from './utils';

export interface EmptyMessageProps extends HtmlElementProps {}

export default function EmptyMessage({
  className,
  ...props
}: EmptyMessageProps) {
  return <div className={twMerge(classes.message, className)} {...props} />;
}
